import classcat from "classcat";
import React from "react";

import {
  Button,
  ConfirmationModal,
  Spinner,
} from "@touchtech/web-baselayer-ui";

import Passcode from "@is/components/Passcode";
import Collection from "@is/components/StoreFavoritesModal/Collection";

import css from "./AddToCollectionModal.module.css";
import useManageAddToCollectionModal from "./hooks/useManageAddToCollectionModal";

type Props = {
  isOpen: boolean;
  styleId: string;
  variantId: string;
  onClose: () => void;
};

const AddToCollectionModal = ({
  isOpen,
  styleId,
  variantId,
  onClose,
}: Props) => {
  const {
    t,
    currentStep,
    passcode,
    allCollections,
    selectedCollectionId,
    buttonState,
    handleCollectionClick,
    handlePasscodeViewClose,
    handleAddToCollection,
  } = useManageAddToCollectionModal({ styleId, variantId, onClose });

  return (
    <ConfirmationModal isOpen={isOpen} onClose={onClose} className={css.modal}>
      {currentStep === 0 ? (
        <div className={css.pendingContainer}>
          <Spinner className="text-display-8xl" />
        </div>
      ) : null}

      {currentStep === 1 ? (
        <div className={css.passcodeContainer}>
          <h1 className={classcat(["text-headline-5xl", css.title])}>
            {t("Enter your passcode")}
          </h1>
          <Passcode
            maskedPasscode={passcode}
            onPasscodeViewClose={handlePasscodeViewClose}
          />
        </div>
      ) : null}

      {currentStep === 2 ? (
        <div className={css.modalContent}>
          <h1 className={classcat(["text-headline-5xl", css.title])}>
            {t("Add to store favorites")}
          </h1>
          <span className={classcat(["text-label-xl", css.text])}>
            {t("Select a collection to add")}
          </span>
          <div className={css.collectionContainer}>
            {allCollections?.map((c) => (
              <Collection
                key={c.id}
                collection={c}
                onCollectionClick={handleCollectionClick}
                selection={true}
                isSelected={selectedCollectionId === c.id}
              />
            ))}
          </div>
          <div className={css.buttonContainer}>
            <Button
              className={css.addButton}
              width="full"
              sizing="lg"
              state={buttonState}
              onClick={handleAddToCollection}
            >
              {t("Add")}
            </Button>
            <Button
              variant="tertiary"
              className={css.cancelButton}
              width="full"
              sizing="lg"
              onClick={onClose}
            >
              {t("Cancel")}
            </Button>
          </div>
        </div>
      ) : null}
    </ConfirmationModal>
  );
};

export default AddToCollectionModal;
